import { mapActions, mapState, mapGetters } from 'vuex';
import datalayerErrorMessage from '@/utils/helpers/message/datalayerErrorMessage.js';

export default {
  name: 'admissionProcessFinishedMixin',
  data() {
    return {
      changeStatusAdmission: false,
      changeStatusPayment: false,
    };
  },
  computed: {
    ...mapState({
      mdmPatient: ({ mdm }) => mdm.data,
      exams: ({ currentAdmission }) =>
        currentAdmission.data.medicalOrders &&
        currentAdmission.data.medicalOrders.length &&
        currentAdmission.data.medicalOrders[0].exams,
      patient: ({ currentAdmission }) => currentAdmission.data.patient,
      paymentType: ({ currentAdmission }) => currentAdmission.data.payments[0],
      selectedUnit: ({ brandUnit }) => brandUnit.data.selectedUnit,
      flowSteps: ({ global }) => global.flowSteps,
    }),

    ...mapGetters({
      hasCompletedFlow: 'global/hasCompletedFlow',
      haveScheduledExams: 'haveScheduledExams',
      isT2FlowAllowed: 'global/isT2FlowAllowed',
      isVaccineFlow: 'global/isVaccineFlow',
    }),
  },
  methods: {
    ...mapActions([
      'updateAdmissionStatus',
      'includePatientToPriorityQueue',
      'removePacientFromTracking',
      'updateBackofficeDone',
    ]),

    /**
     * @method admissionProcessFinished
     * @description
     * Triggers admission changes
     */
    async admissionProcessFinished(processQueue = true) {
      try {
        await this.updateBackofficeDone();

        await this.updateAdmissionStatus('check-in-done');

        if (processQueue) this.includePatientToPriorityQueue();
      } catch (e) {
        this.goNextStep('check_service_desk', datalayerErrorMessage('admissionProcessFinished', e));
      }
    },

    /**
     * @method setAdmissionStatusDone
     * @description
     * Update admission status to ADMISSION_DONE
     */

    async setAdmissionStatusDone() {
      try {
        await this.updateAdmissionStatus('admission-done');
        // Delay para garantir que o paciente foi adicionado na fila do tracking
        // antes de remove-lo (unidade com tracking habilitado)
        setTimeout(() => {
          this.removePacientFromTracking();
        }, 2000);
      } catch (e) {
        this.goNextStep('check_service_desk', datalayerErrorMessage('setAdmissionStatusDone', e));
      }
    },
  },
};
